import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchDailyVehiclesWholeSalesAndStockSummary = (filters) => {
  const clientId = filters.clientId ? `&clientId=${filters.clientId}` : '';
  const startDate = filters.startDate ? `&startDate=${filters.startDate}` : '';
  const endDate = filters.endDate ? `&endDate=${filters.endDate}` : '';

  const allFilters = `${clientId}${startDate}${endDate}`;
  return apiActionCreator({
    'endpoint': `/vehicles/vehicles-sales-and-stock-wholesale?${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_DAILY_VEHICLES_WHOLESALES_SUMMARY,
      ActionTypes.FETCHED_DAILY_VEHICLES_WHOLESALES_SUMMARY,
      [
        ActionTypes.FETCHED_DAILY_VEHICLES_WHOLESALES_SUMMARY_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};
